<template>
  <v-card class="rounded-0" :maxWidth="computedMaxCardWidth" :class="{'deleting': deleting}">
    <div class="top-actions">
      <div class="mx-3">
        &nbsp;
      </div>
      <div>
        &nbsp;
      </div>
      <div>

        <v-dialog
          v-if="computedFailedState || (!option.shortListed && option.owner === currentUserID)"
          v-model="confirmDeleteDialog"
          persistent
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">

            <v-btn
              icon
              small
              light
              class="delete-action"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>

          </template>

          <v-card>
            <v-card-title class="headline grey lighten-2">
              Delete Option
            </v-card-title>

            <v-card-text v-if="hostname" class="py-4">
                Are you sure you want to delete <strong>{{hostname}} / {{ option.name }}</strong> from your options list?
            </v-card-text>
            <v-card-text v-else class="py-4">
                Are you sure you want to delete <strong>{{ option.name }}</strong> from your options list?
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="info"
                text
                rounded
                :disabled="deleting"
                @click="confirmDeleteDialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="error"
                rounded
                :disabled="deleting"
                :loading="deleting"
                @click="deleteOption()"
              >
                Yes, I am sure
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div v-else class="non-breaking-space">&nbsp;</div>
      </div>
    </div>
    <v-divider></v-divider>

    <v-img
      :src="optionImgSrc"
      class="white--text align-center"
      contain
      gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.9)"
      height="200px"
      min-width="248px"
    >
      <v-card-title class="font-weight-bold flex-column">
        Building Option from..
        <v-btn v-if="option.url"
          text
          dark
          x-small
          target="_blank"
          :href="option.url"
        >
          <span v-if="hostname" class="accent--text">{{hostname}}</span><v-icon class="ml-1" color="accent" x-small>mdi-open-in-new</v-icon>
        </v-btn>
      </v-card-title>
    </v-img>

    <v-card-actions class="justify-center">
      <div class="d-flex align-center my-2">
        <div v-if="computedFailedState" class="text-caption text-center">
          <v-icon class="d-block" color="error" small>mdi-alert</v-icon> Sorry. There was a problem building this option. Delete it and try again.
        </div>
        <div v-else>{{ progressMessage }}</div>
      </div>
    </v-card-actions>
    <v-progress-linear
      v-if="scrapingOption"
      color="primary"
      indeterminate
      rounded
      height="4"
    ></v-progress-linear>
  </v-card>
</template>

<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

// Veux types
// import * as DecisionTypes from '../store/types/decision'

export default {
  name: 'UnscrapedOptionCard',
  props: {
    option: Object,
    criteria: Array,
    maxCardWidth: {
      type: Number,
      default: 350
    }
  },
  data () {
    return {
      confirmDeleteDialog: false,
      deleting: false,
      // scrapingOption: false,
      // scrapingFailed: false,
      progressMessageIndex: 0,
      progressMessageInterval: null,
      checkScrapFinishedInterval: null,
      scrapeProgressMessageList: [
        'Starting scraper',
        'Gathering synonyms',
        'Searching matching keywords',
        'Ranking results',
        'Taking reference screenshot'
      ]
    }
  },
  computed: {
    computedMaxCardWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%'
        case 'sm': return '100%'
        default: return this.maxCardWidth
      }
    },
    computedFailedState () {
      // return !this.scrapingOption && (this.scrapingFailed || (this.option.scrapeState === Constants.SCRAPE_STATES.failed))
      return this.option && this.option.scrapeState === Constants.SCRAPE_STATES.failed
    },
    scrapingOption () {
      return !this.computedFailedState
    },
    currentUserID () {
      return firebase.auth().currentUser.uid
    },
    optionImgSrc () {
      return `${Constants.SCREENSHOT_CDN}/unknownimage.png`
    },
    hostname () {
      if (this.option.url) {
        return new URL(this.option.url).hostname
      } else {
        return null
      }
    },
    progressMessage () {
      return this.scrapeProgressMessageList[this.progressMessageIndex]
    }
  },
  mounted: function () {
    this.criteria.forEach((item) => {
      if (!this.option.criteriaValues[item.id]) {
        this.option.criteriaValues[item.id] = {userValue: null, sourceValue: null}
      }
    })
    this.scrapeOptionURL()
  },
  /*watch: {
    // whenever sha256 changes, this function will run
    'option.sha256': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.checkOptionURL()
      }
    }
  },*/
  methods: {
    scrapeOptionURL: async function () {
      // If there is a source URL then scrape that to help with option building
      if (this.option.url && this.option.scrapeState === Constants.SCRAPE_STATES.unscraped) {
        this.startProgressMessageProgression()

        // if (!this.checkScrapFinishedInterval) {
        //   this.startCheckScrapingFinished()
        // }
      }
    },
    // startCheckScrapingFinished: function () {
    //   this.scrapingOption = true
    //   this.scrapingFailed = false
    //   // repeat with the interval of 4 seconds
    //   // this.checkScrapFinishedInterval = setInterval(() => this.checkScrapingFinished(), 4000)
    // },
    // checkScrapingFinished: async function () {
    //   const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
    //   const checkOptionScrapeState = `${Constants.API_BASE_PATH}/decisions/${this.option.decisionId}/options/${this.option.id}/scrapestate`
    //
    //   // If not, check content has not changed
    //   const res = await axios.get(checkOptionScrapeState, {
    //     headers: {
    //       'Authorization': `Bearer ${token}`,
    //     }
    //   })
    //
    //   if (res && res.status === 200 && res.data) {
    //     if (res.data.state === 1) {
    //       // Scrape status is Scraped/Finished
    //       clearInterval(this.checkScrapFinishedInterval)
    //
    //       // Load the latest option data
    //       const getOptionURL = `${Constants.API_BASE_PATH}/decisions/${this.option.decisionId}/options/${this.option.id}`
    //       // console.log(`Calling decision get optoin`)
    //       const optionRes = await axios.get(getOptionURL, {
    //         headers: {
    //           'Content-Type': 'application/json',
    //           'Authorization': `Bearer ${token}`,
    //         }
    //       })
    //
    //       if (optionRes && optionRes.status === 200 && optionRes.data && optionRes.data.status === 'success' ) {
    //         const newOptionData = optionRes.data.optionData
    //         // Update local option model
    //         // TODO mutate the VUEX store instead
    //         this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_DATA}`, {
    //           id: this.option.id,
    //           name: newOptionData.name,
    //           imgSrc: newOptionData.imgSrc,
    //           sha256: newOptionData.sha256,
    //           scrapeResult: newOptionData.scrapeResult,
    //           criteriaValues: newOptionData.criteriaValues,
    //           criteriaValueOptions: newOptionData.criteriaValueOptions,
    //           scrapeState: newOptionData.scrapeState,
    //           contentPushed: newOptionData.contentPushed
    //         })
    //
    //         // this.option.name = newOptionData.name
    //         // this.option.imgSrc = newOptionData.imgSrc
    //         // this.option.sha256 = newOptionData.sha256
    //         // this.option.scrapeResult = newOptionData.scrapeResult
    //         // this.option.criteriaValues = newOptionData.criteriaValues
    //         // this.option.criteriaValueOptions = newOptionData.criteriaValueOptions
    //         // this.option.scrapeState = newOptionData.scrapeState
    //       }
    //
    //       this.checkScrapFinishedInterval = null
    //       this.scrapingOption = false
    //     } else if (res.data.state === Constants.SCRAPE_STATES.failed) {
    //       // Scrape status is Failed
    //       clearInterval(this.checkScrapFinishedInterval)
    //       this.checkScrapFinishedInterval = null
    //       this.scrapingFailed = true
    //       this.scrapingOption = false
    //     }
    //   }
    // },
    deleteOption: async function () {

      if (this.checkScrapFinishedInterval) {
        clearInterval(this.checkScrapFinishedInterval)
      }

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const deleteOptionURL = `${Constants.API_BASE_PATH}/decisions/${this.option.decisionId}/options/${this.option.id}`

      // console.log('Calling delete option')
      this.deleting = true
      const res = await axios.delete(deleteOptionURL, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200 && res.data && res.data.status === "success") {
        // Emit so the main list can update
        this.$emit('onDelete')
        this.confirmDeleteDialog = false
        // this.deleting = false
      } else {
        // console.log(`Unexpected response ${JSON.stringify(res)}`)
        this.deleting = false
        alert('Unexpected response deleting criteria')
      }
    },
    startProgressMessageProgression: function () {
      // repeat with the interval of 5 seconds
      this.progressMessageIndex = 0
      this.progressMessageInterval = setInterval(() => this.incrementProgressMessage(), 3000)
    },
    incrementProgressMessage: function () {
      if (this.progressMessageIndex < this.scrapeProgressMessageList.length -1) {
        this.progressMessageIndex++
      } else if (this.progressMessageInterval) {
        clearInterval(self.progressMessageInterval)
      }
    },
    openURL: function (url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.deleting {
  opacity: 0.2;
}
.v-card__title {
  font-size: 1rem;
  position: relative;
  background-color: rgba(0,0,0,0.6);
  padding: 5px 16px;
}
.top-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 28px;

  .non-breaking-space {
    width: 28px;
  }

  .compare-active {
    background-color: #4caf50;
    color: #FFF;

    &:hover {
      background-color: rgba(76, 175, 80, 0.3);
      color: #607d8b;
    }
  }
}
.delete-action:hover {
  color: #FFF;
  background-color: rgba(244, 67, 54, 0.7);
}
.user-name-caption {
  font-size: 0.65rem;
  position: absolute;
  top: -1px;
}
</style>
